export default function IosRose() {
  return (
    <div
      className="ion-icon-ios-rose"
      dangerouslySetInnerHTML={{
        __html: `<?xml version="1.0" encoding="utf-8"?>
<!-- Generator: Adobe Illustrator 16.2.1, SVG Export Plug-In . SVG Version: 6.00 Build 0)  -->
<!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="512px" height="512px" viewBox="0 0 512 512" enable-background="new 0 0 512 512" xml:space="preserve">
<g>
	<path d="M416,128c-18.863,4.163-36.75,8.786-53.697,13.753c-40.457,11.858-75.509,25.693-105.445,40.015
		c-19.271,9.219-26.236,13.393-51.522,27.859C147.001,243,112,278.926,112,351.889S167.635,480,256,480s144-55.148,144-128.111
		S338.999,224,416,128L416,128z"/>
	<path d="M96,96c41.475,47.079,44.624,103.891,39.382,144.741c12.772-11.274,31.177-25.734,56.144-41.389
		c6.442-4.041,13.312-8.158,20.645-12.322c11.578-6.575,23.538-12.822,35.834-18.765c-9.113-10.898-22.07-20.606-36.631-29.095
		C162.631,110.756,96,96,96,96L96,96z"/>
	<path d="M352,64c0,0-78.623,2.321-130.681,62.469c16.629,9.903,29.735,20.503,38.959,31.533l2.724,3.257
		c37.152-16.794,88.131-34.085,120.998-42.009C377.617,95.827,352,64,352,64L352,64z"/>
	<path d="M176,32c-15.256,22.406-25.684,45.299-30.336,59.997c21.111,6.355,35.475,13.215,61.389,26.574
		c9.505-11.4,20.415-21.626,32.605-30.543C210.342,47.655,176,32,176,32L176,32z"/>
</g>
</svg>
`,
      }}
    />
  )
}
